import $ from 'jquery'
import { pseudoClick } from './functions'

const offCanvas = document.getElementById('main-nav')
if (offCanvas) {
  offCanvas.addEventListener('show.bs.offcanvas', () => {
    document.body.classList.add('header-nav-active')
  })
  offCanvas.addEventListener('hide.bs.offcanvas', () => {
    document.body.classList.remove('header-nav-active')
  })
}

$('.main-navigation .menu-item-has-children > a').on('click', function (e) {
  e.preventDefault()
  e.stopPropagation()
  e.stopImmediatePropagation()

  const $this = $(this)
  const parent = $this.parent()

  $('.main-navigation .menu-item-has-children')
    .not(parent)
    .removeClass('menu-item-has-children--active')

  parent.toggleClass('menu-item-has-children--active')
})

$('.main-navigation .sub-menu').on('click', function () {
  if (pseudoClick(this).after) {
    $(this).parent().removeClass('menu-item-has-children--active')
  }
})
